import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import perms from '../../utils/permissions';
import ReactModal from 'react-modal';

class SendingProgress extends Component {
    render() {
        return (
            <div className="iaupload-sending">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Inserting ...
            </div>
        );
    }
}

class InterestAreasUploadDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onSelectedAreaChanged = this.onSelectedAreaChanged.bind(this);
        this.onSelectedOrientationChanged = this.onSelectedOrientationChanged.bind(this);
        this.onSelectedModelChanged = this.onSelectedModelChanged.bind(this);
        this.onNewAreaChanged = this.onNewAreaChanged.bind(this);
        this.onTitleChanged = this.onTitleChanged.bind(this);
        this.reset = this.reset.bind(this);

        this.state = {
            error: null,
            sending: false,
            modalOpen: false,
            areas: null,
            selected: null,
            new: null,
            title: null,
            orientation: null,
            model: null,
            userModels: perms.getIATaggingModels()
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_InterestAreasUploadDialog');
    }

    reset() {
        this.setState(
            { 
                error: null, 
                sending: false,
                areas: null,
                selected: null,
                new: null,
                orientation: null,
                model: null
            });
    };

    close() {
        this.setState({
            sending: false,
            modalOpen: false,
            areas: null,
            selected: null,
            new: null,
            orientation: null,
            model: null
        })
    };

    open() {
        urlHandler.getInterestAreas((result, status) => {
            if (status === 200) {
                this.setState({
                    error: null,
                    sending: false,
                    areas: 'interestAreas' in result ? result['interestAreas'] : [],
                    modalOpen: true,
                    orientation: null,
                    model: null
                });
            } else if (status === 404) {
                this.setState({
                    error: null,
                    sending: false,
                    areas: [],
                    modalOpen: true,
                    orientation: null,
                    model: null
                });
            }
        })
    };

    handleSubmit() {

        var new_name = this.refs.ia_new && this.refs.ia_new.value.length > 0 ? this.refs.ia_new.value : null;
        var sel_name = this.refs.ia_selected && this.refs.ia_selected.value.length > 0 ? this.refs.ia_selected.value : null;
        var title = this.refs.title && this.refs.title.value.length > 0 ? this.refs.title.value : null;
        var text = this.refs.text && this.refs.text.value.length > 0 ? this.refs.text.value : null;

        if (!title) {
            this.setState({
                error: 'Must specify a document title.'
            })
            return;
        }
        if (!text) {
            this.setState({
                error: 'Must specify document text.'
            })
            return;
        }
        var name = null;
        if (new_name) {
            name = new_name;
        } else if (sel_name) {
            name = sel_name;
        } else {
            this.setState({
                error: 'Must select an existing or specify a new interest area.'
            })
            return;
        }

        this.setState({
            sending: true,
            error: null,
        })
        urlHandler.insertInterestAreaDocument(name, 
            title, 
            this.refs.model.value, 
            this.refs.orientation.value, 
            text, (result, status) => {
            if (status === 201) {
                this.setState({
                    error: null,
                    sending: false,
                    modalOpen: false
                }, () => {
                    if (this.props.onUpload) {
                        this.props.onUpload();
                    }
                });
            } else {
                this.setState({
                    error: decodeURIComponent(result.error_message),
                    sending: false
                });              
            }
        })
    };

    onSelectedAreaChanged() {
        this.setState({
            selected: this.refs.ia_selected.value
        })
    }

    onSelectedOrientationChanged() {
        this.setState({
            orientation: this.refs.orientation.value
        })
    }

    onSelectedModelChanged() {
        this.setState({
            model: this.refs.model.value
        })   
    }

    onNewAreaChanged() {
        this.setState({
            new: this.refs.ia_new.value
        })
    }

    onTitleChanged() {
        this.setState({
            title: this.refs.title.value
        })
    }

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '750px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <div id="rm_InterestAreasUploadDialog">
                <ReactModal ref="uploadIaDocument" 
                    isOpen={this.state.modalOpen}
                    contentLabel="Document Upload Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="iaupload-dialog">
                        <div className="iaupload-header">
                            Insert Document
                        </div>
                        <div className="iaupload-description">
                            <span className='fa fa-upload iaupload-icon'>&nbsp;</span>
                            Upload document text to a specified interest area, or create a new interest area for the document.   
                        </div>
                        <div className="iaupload-content">
                            <div className="iaupload-form">
                                <table className="iaupload-form-table">
                                    <tbody>
                                        <tr>
                                            <td className="iaupload-table-column">
                                                {this.state.areas &&
                                                <div className='form-field-wrapper'>
                                                    <label className='form-label iaupload-form-label'>Select Interest Area (or type new):</label>
                                                    <select className='form-field iaupload-form-field'
                                                            ref='ia_selected'
                                                            onChange={this.onSelectedAreaChanged}
                                                            size={3}
                                                            style={{height: '127px'}}
                                                            disabled={this.state.new && this.state.new.length > 0}
                                                            autoFocus>
                                                        {this.state.areas.map((area, index) => {
                                                            return <option key={index} value={area.trim()}>{area.trim()}</option>
                                                        })}
                                                    </select>
                                                    <input type='text' 
                                                        className='form-field iaupload-form-field iaupload-new-field' 
                                                        ref='ia_new' 
                                                        onChange={this.onNewAreaChanged}/>
                                                </div>
                                                }
                                            </td>
                                            <td className="iaupload-table-column iaupload-table-column-right">
                                                <div className='form-field-wrapper'>
                                                    <label className='form-label iaupload-form-label'>Document Title:</label>
                                                    <input type='text' 
                                                        className='form-field iaupload-form-field' 
                                                        ref='title' 
                                                        onChange={this.onTitleChanged}/>
                                                </div>
                                                <div className='form-field-wrapper squished'>
                                                    <label className='form-label iaupload-form-label'>Orientation:</label>
                                                    <select className='form-field iaupload-form-field'
                                                            ref='orientation'
                                                            defaultValue="positive"
                                                            onChange={this.onSelectedOrientationChanged}>
                                                        <option value="positive">positive</option>
                                                        <option value="negative">negative</option>
                                                    </select>
                                                </div>
                                                <div className='form-field-wrapper squished'>
                                                    <label className='form-label iaupload-form-label'>Tag Model:</label>
                                                    <select className='form-field iaupload-form-field'
                                                            ref='model'
                                                            defaultValue="currentNews"
                                                            onChange={this.onSelectedModelChanged}>
                                                        {this.state.userModels.map((model, index) => {
                                                            return <option key={index} value={model}>{model}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className='form-field-wrapper non-squished'>
                                                    <label className='form-label iaupload-form-label'>Text:</label>
                                                    <textarea className='form-field iaupload-textarea iaupload-form-field' ref='text'/>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br/>
                                {this.state.error &&
                                    <div>
                                        <span className="iaupload-error-msg">{this.state.error}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="iaupload-footer">
                            {this.state.sending ? <SendingProgress /> : null}
                            <button type="button" 
                                className="iaupload-default-button" 
                                onClick={this.handleSubmit}>
                                Upload
                            </button>
                            <button type="button" className="iaupload-default-button" onClick={this.close}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

InterestAreasUploadDialog.propTypes = {
    onUpload: PropTypes.func
};

export default InterestAreasUploadDialog;


